import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { IdentityService } from '../../../identity';


@Component({
    selector: 'configuration',
	templateUrl: './configuration.component.html',
    styleUrls: ['./configuration.component.scss']
})

export class ConfigurationComponent implements OnInit {

    private items: MenuItem[];

    private hideNetworks: boolean;
    private hideProtocolSettings: boolean;
    private hideDeviceGroups: boolean;
    private hideDeviceFilters: boolean;
    private hideMapDrawSettings: boolean;
    private hideEmailSettings: boolean;

    constructor(private identityService: IdentityService) {
        this.items = [
            { label: 'Networks', icon: 'fa-plus', command: this.enclose(this.showNetworks) },
            { label: 'Protocol Settings', icon: 'fa-download', command: this.enclose(this.showProtocolSettings) },
            { label: 'Device Groups', icon: 'fa-refresh', command: this.enclose(this.showDeviceGroups) },
            { label: 'Device Filters', icon: 'fa-refresh', command: this.enclose(this.showDeviceFilters) },
            { label: 'Map Draw Settings', icon: 'fa-refresh', command: this.enclose(this.showMapDrawSettings) },
            { label: 'Email Settings', icon: 'fa-refresh', command: this.enclose(this.showEmailSettings) },
        ];

        // Set default visibility settings
        this.showNetworks();
    }
	
    ngOnInit() {

    }

    public get isLoggedIn(): boolean {
        return this.identityService.isLoggedIn;
    }

    private enclose(method) {
        let self = this;
        return () => { method.call(self) }
    }

    /**
     * Fuctions that set which settings block is showing at a given time
     */
    private showNetworks() {
        this.hideNetworks = false;
        this.hideProtocolSettings = true;
        this.hideDeviceGroups = true;
        this.hideDeviceFilters = true;
        this.hideMapDrawSettings = true;
        this.hideEmailSettings = true;
    }

    private showProtocolSettings()
    {
        this.hideNetworks = true;
        this.hideProtocolSettings = false;
        this.hideDeviceGroups = true;
        this.hideDeviceFilters = true;
        this.hideMapDrawSettings = true;
        this.hideEmailSettings = true;
    }

    private showDeviceGroups() {
        this.hideNetworks = true;
        this.hideProtocolSettings = true;
        this.hideDeviceGroups = false;
        this.hideDeviceFilters = true;
        this.hideMapDrawSettings = true;
        this.hideEmailSettings = true;
    }
    private showDeviceFilters() {
        this.hideNetworks = true;
        this.hideProtocolSettings = true;
        this.hideDeviceGroups = true;
        this.hideDeviceFilters = false;
        this.hideMapDrawSettings = true;
        this.hideEmailSettings = true;
    };

    private showMapDrawSettings() {
        this.hideNetworks = true;
        this.hideProtocolSettings = true;
        this.hideDeviceGroups = true;
        this.hideDeviceFilters = true;
        this.hideMapDrawSettings = false;
        this.hideEmailSettings = true;
    };

    private showEmailSettings() {
        this.hideNetworks = true;
        this.hideProtocolSettings = true;
        this.hideDeviceGroups = true;
        this.hideDeviceFilters = true;
        this.hideMapDrawSettings = true;
        this.hideEmailSettings = false;
    };
}

